import {apiClient} from 'common/util/api-client';

import {appApiUrl} from '../utils';

type OnboardingChecklistResult = {
  org_ownership: boolean;
  implementation: boolean;
  viewed_event: boolean;
  board_creation: boolean;
};

export function getOnboardingChecklist(
  projectId: string,
  backgroundRefresh?: boolean,
): Promise<OnboardingChecklistResult> {
  return apiClient.get(appApiUrl(`onboarding-checklist`, {projectId}), undefined, {
    importance: backgroundRefresh ? `low` : `auto`,
  });
}
